.textfield-container {
    border: 1px solid var(--ai-purple-border);
    border-radius: 3px;
}

.textfield-container > textarea {
    border: none;
    border-radius: 3px;
    background-color: var(--white);
    width: 100%;
    box-sizing: border-box;
}
